import axios from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    // Let the caller handle a 401 instead of the global sign-in redirect.
    skipAuthRedirect?: boolean;
  }
}

export const SESSION_EXPIRED_EVENT = 'session-expired';
const SESSION_EXPIRED_REDIRECT_DELAY = 5000;
// Several requests can 401 at once; show the dialog and redirect only once.
let isSessionExpiring = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_END_POINT,
});

axiosInstance.interceptors.request.use(
  config => {
    let accessToken = ``;
    if (sessionStorage.hasOwnProperty('access_token')) {
      accessToken = sessionStorage.getItem('access_token') as string;
    } else {
      accessToken = localStorage.getItem('access_token') as string;
    }
    if (accessToken) {
      config.headers = {
        authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const currentPath = window.location.pathname;

    const clearStorage = () => {
      localStorage.clear();
      sessionStorage.clear();
    };

    if (
      status === 401 &&
      currentPath !== '/sign-in' &&
      !error?.config?.skipAuthRedirect
    ) {
      clearStorage();
      // A request that carried a token means a live session just expired: let
      // App show the "session expired" dialog before redirecting.
      if (error?.config?.headers?.authorization) {
        if (!isSessionExpiring) {
          isSessionExpiring = true;
          window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
          setTimeout(() => {
            window.location.href = '/sign-in';
          }, SESSION_EXPIRED_REDIRECT_DELAY);
        }
      } else {
        window.location.href = '/sign-in';
      }
    }

    if (status === 503 && currentPath !== '/maintenance') {
      clearStorage();
      window.location.href = '/maintenance';
    }
    return Promise.reject(error);
  },
);

export const apiGet = axiosInstance.get;
export const apiPost = axiosInstance.post;
export const apiPut = axiosInstance.put;
export const apiDelete = axiosInstance.delete;
export const apiPatch = axiosInstance.patch;

export default axiosInstance;
